import React from "react";
import SkillsComparison from "./SkillsComparison";
import {Element} from "react-scroll";

interface SkillsComparisonProps {
    lowSkills?: group[];
    templateAnswerResult?: string
    activeTemplate?: boolean
    feedbackAssisstant: Map<string, string>
}

interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string,
    acronym?: string
}
const LowSkill: React.FC<{ data: SkillsComparisonProps, content?: Record<string, (string|boolean)[]>, defaultTemplate?: boolean  }> = ({ data, content, defaultTemplate }) => {
    return (
        <Element name="lowSkills">
            <div className={"div-section"} style={{marginTop: '48px'}}>
                <div style={{height: '40px'}}>
                    <span className="title-section">
                        {  content?.TITLE?.[0] ? typeof content?.TITLE?.[0] != 'boolean' ? content?.TITLE?.[0] : <>偏差値が<span style={{color: '#F25A5A'}}>低かった</span>スキル</> : <>偏差値が<span style={{color: '#F25A5A'}}>低かった</span>スキル</>}
                    </span>
                </div>

                <div className={"border-title"}>
                    <div className={"underline-title-high-low-skill"}></div>
                </div>
                {
                    data.lowSkills &&
                    <SkillsComparison data={data.lowSkills} feedback={(content?.FEEDBACK?.[0] || defaultTemplate) ? data.feedbackAssisstant.get('2') != null ? data.feedbackAssisstant.get('2') : '' : ''} text={(content?.TEXT?.[0] || defaultTemplate)  ? typeof content?.TEXT?.[0] === "string" ? content?.TEXT?.[0] : '' : ''}/>
                }
            </div>
        </Element>
    );
};

export default LowSkill;
